<app-material [material]="false">
    <div class="header" header>
        <app-activity *ngIf="activity"
                      [activity]="activity"
                      [showDetails]="true"
                      [canEdit]="true"
                      [canDelete]="!inUse"
                      (edit)="onEditActivityClick($event)"
                      (delete)="onDeleteActivityClick($event)"
        ></app-activity>
    </div>
    <div class="content" body>
        <div class="search">
            <app-search-bar [input]="searchQuery"
                            (search)="onSearch($event)">
            </app-search-bar>
            <app-button type="primary"
                        (click)="onAddTaskClick($event)">
                {{ 'generic.buttons.add' | translate }}
            </app-button>
        </div>
        <div class="list" [class.empty]="tasks.length === 0" *ngIf="!(loadingTasks$ | async) else loading">
            <div class="no-tasks" *ngIf="tasks.length === 0">
                <p class="zero">0</p>
                <p class="tasks">{{ 'admin.toolMaintenancePlans.activities.details.tasks' | translate }}</p>
            </div>
            <div *ngIf="tasks.length > 0" class="tasks">
                <app-task *ngFor="let task of tasks"
                          [task]="task"
                          [highlighted]="task.id === selectedTask?.id"
                          [canDelete]="true"
                          [canDuplicate]="true"
                          (toggleHighlight)="onSelectTask($event)"
                          (delete)="onDeleteTask($event)"
                          (duplicate)="onDuplicateTask($event)">
                </app-task>
            </div>
        </div>
        <app-task-form class="add-form"
                       *ngIf="(isFormVisible && !(loading$ | async)) else loading"
                       [roles]="roles"
                       [isEdit]="selectedTask ? true : false"
                       (create)="onCreate($event)"
                       (update)="onUpdateTask($event)"
                       (close)="onClose()">
        </app-task-form>
    </div>
</app-material>

<app-confirmation-modal #removeActivity
                        title="{{'admin.toolMaintenancePlans.notifications.confirmRemoveActivity' | translate }}"
                        question="{{'admin.toolMaintenancePlans.notifications.confirmRemoveActivityQuestion' | translate: {activityName: toBeDeletedActivity?.name} }}"
                        [showConfirmButton]="true"
                        (confirmEvent)="onConfirmDeleteActivity()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-confirmation-modal #removeTask
                        title="{{'admin.toolMaintenancePlans.notifications.confirmRemoveTask' | translate }}"
                        question="{{'admin.toolMaintenancePlans.notifications.confirmRemoveTaskQuestion' | translate: {taskName: toBeDeletedTask?.name} }}"
                        [showConfirmButton]="true"
                        (confirmEvent)="onConfirmDeleteTask()"
                        [confirmOnlyMode]="true">
</app-confirmation-modal>

<app-activity-modal [title]="'admin.toolMaintenancePlans.activities.modal.editTitle' | translate"
                    [dropdownItems]="this.roles"
                    (submit)="onEdit($event)">
</app-activity-modal>

<ng-template #loading>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
